import { Box } from '@mui/material';
import { useState } from 'react';
import useStyles from './styles';

export const FooterModal = ({ closeModal, counter, setCounter, selected }) => {
    const classes = useStyles();
    const [check, setCheck] = useState(false);
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center'
            }}>
            <label
                style={{
                    position: 'absolute',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '13px',
                    lineHeight: '20px',
                    color: '#182D55',
                    marginTop: '294px',
                    marginLeft: '22px',
                    display: 'flex'
                }}>
                <input
                    type="checkbox"
                    value={check}
                    onClick={() => setCheck(!check)}
                    style={{
                        width: '20px',
                        height: '20px',
                        marginRight: '5px'
                    }}
                />
                Make it primary
            </label>
            <button
                className={classes.cancelButton}
                onClick={closeModal}
                style={{
                    marginLeft: 10
                }}>
                Cancel
            </button>
            <button
                className={selected ? classes.applyPaymentEnabled : classes.applyPaymentDisabled}
                onClick={counter => setCounter(counter + 1)}
                disabled={!selected}
                style={{
                    marginLeft: 10
                }}>
                Next
            </button>
        </Box>
    );
};
